import {FormStepType} from '../../../../../blocks/FormBlock'
import commentsData from '../sections/commentsData'
import deliveryData from '../sections/personal/deliveryData'
import invoiceData from '../sections/personal/invoiceData'
import personalData from '../sections/personal/personalData'
import privacyData from '../sections/privacyData'
import takeAwayData from '../sections/takeAwayData'

const personal: FormStepType = {
	id: 2,
	parent_id: 0,
	channel: 'step',
	label: 'Persoonlijk gebruik',
	sections: [
		personalData,
		invoiceData,
		deliveryData,
		takeAwayData,
		commentsData,
		privacyData
	],
	submit_text: 'Bevestig'
}

export default personal
